import {useEffect, useState} from "react";
import {httpsCallable} from "firebase/functions";
import {FUNCTION_NAMES} from "../../utils/functionNames";

export default function useInvitePreview(functions, token) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({token, loading: true, teamName: "", error: ""});
  useEffect(() => {
    let alive = true;
    setState({token, loading: true, teamName: "", error: ""});
    if (!token || !/^[A-Za-z0-9_-]{10,200}$/.test(token)) {
      setState({token, loading: false, teamName: "", error: "This invitation link is incomplete or invalid. Ask the team for a new link."});
      return undefined;
    }
    if (!functions) {
      setState({token, loading: false, teamName: "", error: "The invitation service is unavailable. Please try again."});
      return undefined;
    }
    httpsCallable(functions, FUNCTION_NAMES.getTeamInvitePreview)({token}).then(result => {
      if (!result.data?.teamName || typeof result.data.teamName !== "string") throw new Error("Invalid preview");
      if (alive) setState({token, loading: false, teamName: result.data.teamName, error: ""});
    }).catch(error => {
      if (alive) setState({token, loading: false, teamName: "", error: error.code === "functions/not-found" || error.code === "functions/invalid-argument"
        ? "This invitation has expired or is no longer available. Ask the team for a new link."
        : "We couldn’t load this invitation. Check your connection and try again."});
    });
    return () => {alive = false;};
  }, [functions, token, attempt]);
  return {...(state.token === token ? state : {loading: true, teamName: "", error: ""}), retry: () => setAttempt(value => value + 1)};
}
